export default __webpack_public_path__ + "static/media/uxEngineeringLogo.adc052c5.svg";